<div class="notification-toast-container">
  @for (notification of activeNotifications; track notification.id) {
    <div class="notification-toast" (click)="openNotificationUrl(notification)">
      <div class="notification-toast-content">
        <div class="notification-icon">
          @if (notification.icon && !hasIconError(notification.id)) {
            <img
              class="notification-icon-image"
              [src]="notification.icon"
              alt=""
              (error)="onNotificationIconError(notification.id)" />
          } @else {
            <i class="ph-fill ph-bell"></i>
          }
          <dk-unread-icon class="unread-red-dot"></dk-unread-icon>
        </div>
        <div class="notification-content">
          <div class="notification-header">
            <span class="notification-title">
              {{ notification.subject }}
            </span>
            <span class="notification-date">
              {{ getFormattedTime(notification) }}
            </span>
          </div>
          <div class="notification-description">
            {{ notification.notificationContent }}
          </div>
        </div>
        <div class="close-button" (click)="closeToast(notification); $event.stopPropagation()">
          <i class="ph-fill ph-x"></i>
        </div>
      </div>
    </div>
  }

  @if (showMoreToast) {
    <div class="notification-toast show-more-toast" (click)="onShowMoreClick()">
      <div class="notification-toast-content">
        <div class="notification-icon">
          <i class="ph-fill ph-bell"></i>
        </div>
        <div class="notification-content">
          <div class="notification-header">
            <span class="notification-title">
              +{{ overflowCount }} more notification{{ overflowCount > 1 ? 's' : '' }}
            </span>
          </div>
          <div class="notification-description">
            Click to view all notifications
          </div>
        </div>
        <div class="close-button" (click)="closeShowMoreToast(); $event.stopPropagation()">
          <i class="ph-fill ph-x"></i>
        </div>
      </div>
    </div>
  }
</div>
